import React, { useMemo, useState } from "react";

import { getBrandName } from "../common/brand";
import InnerHeader from "./InnerHeader";

export default function MessageBox({
  title = "",
  globalData,
  onBack,
}) {
  const [open, setOpen] = useState(false);
  const brandName = getBrandName();

  const displayMessages = useMemo(() => {
    const notices = globalData?.general?.notice || [];

    if (Array.isArray(notices) && notices.length > 0) {
      return notices.filter(Boolean);
    }

    return [`Welcome to ${brandName}`];
  }, [globalData, brandName]);

  const topLabel = displayMessages[0] || "No Message";

  return (
    <div style={styles.page}>
     <InnerHeader title=""/>

      <div style={styles.content}>
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          style={{
            ...styles.rowBtn,
            borderBottom: open ? "none" : "1px solid #5f58b8",
          }}
        >
          <span style={styles.rowText}>{topLabel}</span>

          <svg
            viewBox="0 0 24 24"
            style={{
              ...styles.chevron,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <path
              d="M6 9L12 15L18 9"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {open && (
          <div style={styles.dropdownBox}>
            {displayMessages.map((item, index) => (
              <div
                key={`${item}-${index}`}
                style={{
                  ...styles.messageItem,
                  borderBottom:
                    index !== displayMessages.length - 1
                      ? "1px solid rgba(255,255,255,0.04)"
                      : "none",
                }}
              >
                {item || `Welcome to ${brandName}`}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background: "#040525",
    color: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
  },

  header: {
    height: 64,
    background: "#37346f",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 14px",
  },

  backBtn: {
    width: 30,
    height: 30,
    border: "none",
    background: "transparent",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: 0,
  },

  backIcon: {
    width: 28,
    height: 28,
  },

  headerTitle: {
    fontSize: 22,
    fontWeight: 700,
    lineHeight: 1,
  },

  headerSpacer: {
    width: 40,
    height: 40,
  },

  content: {
    padding: "0 8px",
  },

  rowBtn: {
    width: "100%",
    minHeight: 42,
    background: "transparent",
    border: "none",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 10px 0 10px",
    cursor: "pointer",
  },

  rowText: {
    fontSize: 15,
    fontWeight: 700,
    textAlign: "left",
  },

  chevron: {
    width: 20,
    height: 20,
    color: "#ffffff",
    transition: "transform 0.2s ease",
    flexShrink: 0,
  },

  dropdownBox: {
    margin: "0 2px",
    background: "#37346f",
    borderTop: "1px solid #5f58b8",
    padding: "2px 18px",
  },

  messageItem: {
    minHeight: 38,
    display: "flex",
    alignItems: "center",
    color: "#ffffff",
    fontSize: 14,
  },
};